import { ArrowRight, ListChecks } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function CompanyQueueIntro({ onJoin }: { onJoin: () => void }) {
  return (
    <section className="border-primary/20 bg-primary-light rounded-2xl border p-5 sm:p-7">
      <span className="text-primary inline-flex items-center gap-2 text-sm font-semibold">
        <ListChecks className="h-5 w-5" aria-hidden="true" /> Atendimento por fila
      </span>
      <h2 className="mt-3 text-2xl font-bold">Entre na fila e acompanhe sua vez</h2>
      <p className="text-muted-foreground mt-2 max-w-lg text-sm leading-relaxed">
        Identifique-se com seu telefone e escolha o profissional para entrar na fila. Depois, acompanhe sua posição por
        aqui. Os serviços você pode decidir no local.
      </p>
      <Button onClick={onJoin} className="mt-5 h-12 w-full gap-2 rounded-xl sm:w-auto">
        Entrar na fila <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Button>
      <p className="text-muted-foreground mt-3 text-xs">
        Sem horário marcado. Aguarde no estabelecimento para ser chamado.
      </p>
    </section>
  );
}
